import React, { useContext, useState } from "react";
import Utils from "../../../Common/Utils";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AuthManager from "../../../Common/AuthManager";
import AppSettings from "../../../Settings/AppSettings";
import { AppContext } from "../../../Context/AppContext";
import LoadingSuccessErrorAlert from "../Rules/Components/LoadingSuccessErrorAlert";
import Label from "../../Common/components/Label";
import { toast } from "Components/DesignSystem/Toast/useToast";

const ProductExport = ({ categoriesList, setCategoriesList }) => {
  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  let appData = useContext(AppContext);
  let industryId =
    appData.get_selected_industry() && appData.get_selected_industry().id;
  // const [selectedCategory, setselectedCategory] = useState({id: null, name: ''})
  // const [selectedCategoriesList, setSelectedCategoriesList] = useState(categoriesList)
  const [Loading, setLoading] = useState({
    status: "",
    message: "",
  });
  let [downloadUrl, setDownloadUrl] = React.useState(null);
  let [downloadStausLog, setDownloadStausLog] = React.useState(null);

  async function do_download_pdw() {
    let ids = "";
    categoriesList.forEach(function (item, index) {
      if (item.selected) {
        ids = ids + (ids === "" ? "" : ",") + item.id;
      }
    });
    setDownloadStausLog(null);
    setDownloadUrl(null);
    let newurl = `${api_base_url}industry/${industryId}/category/${ids}/report/product`;

    let res = await ServiceWrapper.doGet(
      newurl,
      null,
      null,
      AuthManager.getGmsToken()
    );
    setDownloadStausLog("Making request");
    setTimeout(() => {
      check_download_status(res.data.jobid);
    }, 1000);
  }

  async function check_download_status(jobid) {
    let ret = await ServiceWrapper.doGet(
      api_base_url + "job/status/" + jobid,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (await !ret.errorfound) {
      setDownloadStausLog(ret.data.status);
      if (!ret.data.data) {
        if(ret.data?.processing){
          setTimeout(() => {
            check_download_status(jobid);
          }, 1000);
        } else if(ret.data.error){
          toast.error(ret.data.status);
        } else {
            toast.info(ret.data.status);
        }
      } else {
        setDownloadUrl(ret.data.data.url);

        setDownloadStausLog("completed");
        toast.success("Completed");
        setTimeout(() => {
          setDownloadUrl(null);
          setDownloadStausLog(null);
        }, 4000);
      }
    }
  }

  return (
    <div>
      <div style={{ marginLeft: 5 }}>
        <Label message="Select a category" fontSize={0.9} />
      </div>
      <div className="row">&nbsp;</div>
      <div className="row">
        {categoriesList.map((item, index) => (
          <React.Fragment key={item.id}>
            <div className="col-sm-3">
              <div className="form-check" style={{ marginBottom: 10 }}>
                <label className="form-check-label">
                  <input data-testid={`export-category-checkbox-${item.id}`}
                    style={{ fontSize: 11, color: "rgb(9, 28, 170)" }}
                    type="checkbox"
                    className="form-check-input"
                    checked={item.selected}
                    value={item.id}
                    onChange={(e) => {
                      categoriesList[index].selected = !item.selected;
                      setLoading({ status: null, message: null });
                      return setCategoriesList(categoriesList);
                    }}
                  />
                  {item.name}
                </label>
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
      <br />
      <button
        type="button"
        style={{
          fontFamily: "Noto Sans",
          fontSize: "0.75rem",
          fontWeight: 500,
          background: "rgb(9, 28, 170)",
          border: "1px solid rgb(9, 28, 170)",
          borderRadius: "4px",
          cursor: "pointer",
          color: "rgb(255, 255, 255)",
          width: "90px",
          height: "35px",
          marginRight: "6px",
        }}
        disabled={downloadStausLog != null}
        onClick={() => do_download_pdw()}
        data-testid="export-download-btn"
      >
        Download
      </button>
      <div className="mt-3">
        <LoadingSuccessErrorAlert loading={Loading} />
      </div>

      {downloadStausLog !== null && (
        <>
          <div className="p-2 bg-white alert alert-primary small" role="alert">
            &nbsp;&nbsp;
            <span className="fas fa-circle-notch fa-spin" />
            <strong>&nbsp;&nbsp;{downloadStausLog}</strong>
          </div>
        </>
      )}

      <iframe
        style={{ display: "none" }}
        src={downloadUrl}
        id="iframe_pdw_download"
        title="ProductExport"
      />
    </div>
  );
};
export default ProductExport;
